(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ev-travel-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){
 if(event.target.id!=='TravelVariant')return;
 const select=event.target,option=select.selectedOptions[0],form=select.closest('form'),root=select.closest('[data-travel-product]');
 if(!option||!form||!root)return;
 const button=form.querySelector('.ev-product-buy'),prices=root.querySelector('[data-product-prices]');
 const available=option.dataset.available==='true',discounted=option.dataset.showCompare==='true';
 if(prices){const regular=prices.querySelector('[data-regular-price]'),sale=prices.querySelector('[data-sale-price]');if(regular){regular.textContent=option.dataset.regularPrice;regular.hidden=!discounted;}if(sale)sale.textContent=option.dataset.salePrice;
 const label=prices.querySelector('[data-sale-label]'),badge=prices.querySelector('[data-sale-badge]'),saving=prices.querySelector('[data-sale-saving]');if(label)label.hidden=!discounted;if(badge){const pct=parseInt(option.dataset.salePercent,10)||0;badge.hidden=!discounted||pct<1;badge.textContent=pct+'% OFF';}const save=prices.querySelector('[data-sale-save]');if(save){save.hidden=!discounted;save.textContent='Save '+option.dataset.saving;}if(saving){saving.hidden=!discounted;saving.textContent='You save '+option.dataset.saving+' on the complete three-piece set.';}}
 if(button){button.disabled=!available;button.textContent=available?button.dataset.addText:button.dataset.unavailableText;}
 const scope=root.closest('.shopify-section')||document,bar=scope.querySelector('[data-sticky-buy]');if(bar){const price=bar.querySelector('[data-sticky-price]'),buy=bar.querySelector('button');if(price)price.textContent=option.dataset.salePrice;if(buy&&button){buy.disabled=!available;buy.textContent=button.textContent;}}
 form.querySelectorAll('.ev-express,.ev-installments,.ev-eta').forEach(el=>{el.hidden=!available;});
 const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
});
document.addEventListener('click',function(event){const button=event.target.closest('.ev-product-swatches button');if(!button)return;const root=button.closest('[data-travel-product]');const image=root.querySelector('.ev-product-gallery img');image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.textContent+' three-piece luggage set';root.querySelectorAll('.ev-product-swatches button').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
